// extracted by mini-css-extract-plugin
export default {"likeAnimation":"src_likeAnimation__BLhk8"};